var map = {
	"./Icon.svg": 4590,
	"./Timer_Close.svg": 4465,
	"./alarm.svg": 3840,
	"./badge-basic.svg": 127,
	"./badge-community.svg": 8402,
	"./badge-membership.svg": 6619,
	"./badge-participation.svg": 4026,
	"./badge-role.svg": 1979,
	"./badge.svg": 2558,
	"./bell-notification.svg": 2442,
	"./bell-ring.svg": 2897,
	"./bg_image.svg": 9562,
	"./calendar-add.svg": 8845,
	"./calendar-check.svg": 2940,
	"./calendar-days.svg": 8117,
	"./calendar-duration.svg": 7980,
	"./calendar-event.svg": 1788,
	"./calendar.svg": 7915,
	"./checklist.svg": 2235,
	"./chevron-left.svg": 1156,
	"./clock-check.svg": 3194,
	"./clock.svg": 1893,
	"./cloud-off.svg": 7292,
	"./color.svg": 1854,
	"./copy.svg": 4198,
	"./cross.svg": 6219,
	"./danwload.svg": 6545,
	"./dark.svg": 8769,
	"./dashboard.svg": 6551,
	"./delete-solid.svg": 4222,
	"./discord.svg": 9003,
	"./download.svg": 3733,
	"./edit-pencil.svg": 1025,
	"./edit-solid.svg": 5043,
	"./facebook.svg": 8973,
	"./file-solid.svg": 8085,
	"./file-upload.svg": 3099,
	"./finger.svg": 3822,
	"./globe.svg": 6248,
	"./help.svg": 4320,
	"./image.svg": 6296,
	"./infinity.svg": 6177,
	"./info.svg": 4069,
	"./layer.svg": 9308,
	"./light.svg": 5959,
	"./link-break.svg": 5599,
	"./link.svg": 5765,
	"./linkedin.svg": 1267,
	"./location.svg": 9716,
	"./log-out.svg": 698,
	"./logo-comect-blue.svg": 2681,
	"./magnifying-glass.svg": 8417,
	"./mail.svg": 7884,
	"./map.svg": 798,
	"./member-count.svg": 6985,
	"./more-vertical.svg": 2338,
	"./note-edit.svg": 1218,
	"./notebook.svg": 4522,
	"./paper-plane.svg": 8360,
	"./plus.svg": 9989,
	"./qr-code.svg": 9686,
	"./searchIcon.svg": 3225,
	"./select-multiple.svg": 2994,
	"./send-solid.svg": 1773,
	"./settings.svg": 7514,
	"./show.svg": 1842,
	"./smiley.svg": 2644,
	"./star.svg": 2413,
	"./text-align-left.svg": 8954,
	"./trash-empty.svg": 9385,
	"./trash.svg": 6509,
	"./triangle-exclamation.svg": 8949,
	"./twitter.svg": 5850,
	"./unfold-more.svg": 4577,
	"./user-add.svg": 1742,
	"./user-card-id.svg": 4259,
	"./user-group.svg": 6266,
	"./user-square.svg": 7344,
	"./wavy-check.svg": 377,
	"./website.svg": 1872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5450;